<template>
  <custom-button
    @click.native="copyTextToClipboard(textForCopy)"
    :type="type"
  >
    <slot>
      Copy
    </slot>
  </custom-button>
</template>

<script>
import CustomButton from '@/components/inputs/Button'

export default {
  name: 'CopyToClipboardButton',
  components: { CustomButton },
  props: {
    textForCopy: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'plain'
    }
  },
  methods: {
    successfulCopy () {
      this.$emit('success')
    },
    unsuccessfulCopy (message = '') {
      this.$emit('unsuccess', message)
    },
    fallbackCopyTextToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text

      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')

        if (successful) {
          this.successfulCopy()
        } else {
          this.unsuccessfulCopy()
        }
      } catch (err) {
        this.unsuccessfulCopy(err)
      }

      document.body.removeChild(textArea)
    },
    copyTextToClipboard (text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text)
        return
      }

      navigator.clipboard.writeText(text).then(() => {
        this.successfulCopy()
      }, (err) => {
        this.unsuccessfulCopy(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
